import type { FormFillIssue } from "#app/lib/form-fill-dialog-context";
import type { FormProperty } from "#app/lib/forms";

export function propertyValueOf(issue: FormFillIssue, property: FormProperty): unknown {
  switch (property) {
    case "address":
      return issue.address?.wholeAddress ? { wholeAddress: issue.address.wholeAddress } : undefined;
    case "assignees":
      return (issue.assignees ?? [])
        .filter((ref) => ref.entityType === "user")
        .map((ref) => ref.entityId);
    case "description":
      return issue.description ?? undefined;
    case "issueSource":
      return issue.issueSourceId ? [issue.issueSourceId] : undefined;
    case "issueType":
      return issue.issueTypeId ? [issue.issueTypeId] : undefined;
    case "name":
      return issue.name ?? undefined;
    case "stage":
      return issue.stageId ? [issue.stageId] : undefined;
    case "teams":
      return (issue.teams ?? []).map((team) => team.teamId);
    case "workflow":
      return issue.workflowId ? [issue.workflowId] : undefined;
  }
}
